import { atom } from "jotai";
import { TotemConfig } from "../ObjectTypes";

export const totemConfigState = null;

export const totemConfigInfo = atom<TotemConfig | null>(totemConfigState);
